import Switch from "@components/Switch/Switch";
import { Checkbox } from "@components/ui/checkbox";
import { getHiringCompanyMembers } from "@endpoints/hiringCompany/hiringCompany";
import { ITeamMember } from "@type/hiringStaff.type";
import { useEffect, useState } from "react";
import SelectTeamMemberDialog from "./SelectTeamMemberDialog";

type HiringTeamMembersProps = {
  jobRequirementTeamMembers: ITeamMember[];
  selectedHiringMembers: ITeamMember[];
  handleSelectOrDeselectMember: (member: ITeamMember) => void;
};

const HiringTeamMembers = (props: HiringTeamMembersProps) => {
  const {
    jobRequirementTeamMembers,
    selectedHiringMembers,
    handleSelectOrDeselectMember,
  } = props;
  const [sendPollSwitch, setSendPollSwitch] = useState(false);
  const [teamMemberList, setTeamMemberList] = useState<ITeamMember[]>([]);
  const [openDialog, setOpenDialog] = useState(false);

  const fetchTeamMembers = async () => {
    try {
      const { success, data } = await getHiringCompanyMembers();
      if (success) {
        setTeamMemberList(data?.members);
      }
    } catch (error) {
      console.error("Error: fetching team members", error);
    }
  };

  useEffect(() => {
    if (sendPollSwitch && !teamMemberList?.length) {
      fetchTeamMembers();
    }
  }, [sendPollSwitch]);

  useEffect(() => {
    if (jobRequirementTeamMembers?.length)
      setTeamMemberList(jobRequirementTeamMembers);
  }, [jobRequirementTeamMembers]);

  return (
    <div className="flex flex-col">
      {/* Hiring member add switch */}
      <div className="flex items-center justify-between mb-8">
        <span className="font-medium text-xs text-primary">
          Do you want to first send poll to your hiring team members ?
        </span>
        <Switch
          isChecked={sendPollSwitch}
          onToggle={(value) => setSendPollSwitch(value?.target?.checked)}
        />
      </div>
      {/* Member listing */}
      <div className="flex flex-col gap-2">
        <span className="font-semibold text-xs text-primary">
          Select hiring team members for availability poll
        </span>
        {jobRequirementTeamMembers?.length ? (
          <div className="flex flex-col border py-3 px-5 rounded-md gap-2">
            {jobRequirementTeamMembers?.map((member) => {
              const isSelected = !!selectedHiringMembers?.find(
                (item) => item?._id === member?._id
              );
              return (
                <div key={member?._id} className="flex items-center gap-4">
                  <Checkbox
                    checked={isSelected}
                    onClick={() => handleSelectOrDeselectMember(member)}
                    className="w-5 h-5"
                  />
                  <div className="flex items-center gap-3.5">
                    {member?.profilePic ? (
                      <img
                        src={member?.profilePic}
                        className="w-6 h-6 rounded-md"
                      />
                    ) : (
                      <div className="flex justify-center items-center w-6 h-6 rounded-full bg-gray-200 text-xs font-medium text-primary">
                        {member?.firstName?.charAt(0)}
                      </div>
                    )}
                    <span className="text-xs font-medium text-light-black">
                      {member?.firstName} {member?.lastName}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          // Add member banner
          <div className="flex flex-col gap-4 border rounded-md p-3">
            <span className="font-medium text-xs">
              Looks like you haven’t added any hiring team members yet. Would
              you like to add them now?
            </span>
            <div className="flex items-center gap-2">
              <button className="font-semibold text-xs border border-primary rounded-md h-8 px-5 hover:bg-gray-50">
                Skip
              </button>
              <button
                onClick={() => {
                  setOpenDialog(true);
                  setSendPollSwitch(true);
                }}
                className="font-semibold text-xs rounded-md h-8 px-5 bg-primary text-white hover:bg-black"
              >
                Proceed
              </button>
            </div>
          </div>
        )}
      </div>
      {/* SelectTeamMemberDialog */}
      <SelectTeamMemberDialog
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
      />
    </div>
  );
};

export default HiringTeamMembers;
